import membersService from "services/admin/membersService"
import { useQuery } from "@tanstack/react-query"

export const useGetMembers = (orgID: string) => {
    return useQuery({
        queryKey: ['members', orgID],
        queryFn: async () => {
            const response: any = await membersService.getAll({ orgID })
            return response.data
        },
    })
}